module.exports = __webpack_public_path__ + "img/home-delivery.739703f5.jpeg";